import { ProfilePk } from "./common"

export enum DisciplineActionsEnum {
  COUNSEL = "COUNSEL",
  VERBAL = "VERBAL",
  WRITTEN_1 = "WRITTEN_(1)",
  WRITTEN_FINAL = "WRITTEN_(FINAL)",
  NOTICE_1 = "NOTICE_(1)",
  HEARING = "HEARING",
  ADD_CATCH_ALL = "ADD_CATCH_ALL",
  TERMINATE = "TERMINATE",
}

export type BulkDisciplineActionSchema = {
  id: string
  profilePk: ProfilePk
  name: string
  surname: string
  idPassport: string
  action: DisciplineActionsEnum
  offence: string
  isComplete: boolean
  isExpired?: boolean
  expiry: string // unixms
  creationUnixMs: string // unixms
  lastModifiedUnixMs?: string // unixms
  contextualData?: Record<string, any>
  isSelfService?: boolean
  selfServiceParams?: {
    hasReceived?: boolean
    hasRead?: boolean
    hasAccepted?: boolean
    hasRequestedReview?: boolean
    hasCompletedReview?: boolean
  }
}
